import React, { useState, useEffect } from 'react';
import { CheckCircle, AlertTriangle, XCircle, Info, X } from 'lucide-react';
import './FeedbackModal.css';

const FeedbackModal = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info' // 'success' | 'error' | 'warning' | 'info'
  });

  useEffect(() => {
    const handleOpenModal = (event) => {
      const { title, message, type = 'info' } = event.detail || {};
      let formattedMessage = message;
      if (typeof message === 'object' && message !== null) {
        try {
          formattedMessage = JSON.stringify(message, null, 2);
        } catch {
          formattedMessage = String(message);
        }
      }
      setModalState({
        isOpen: true,
        title: title || (type === 'error' ? 'Erreur' : type === 'success' ? 'Succès' : 'Information'),
        message: String(formattedMessage || ''),
        type
      });
    };

    window.addEventListener('app-modal', handleOpenModal);

    // Global helper
    window.showAppModal = (titleOrOptions, message, type = 'info') => {
      if (typeof titleOrOptions === 'object' && titleOrOptions !== null) {
        window.dispatchEvent(new CustomEvent('app-modal', { detail: titleOrOptions }));
      } else {
        window.dispatchEvent(new CustomEvent('app-modal', {
          detail: { title: titleOrOptions, message, type }
        }));
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        setModalState((prev) => ({ ...prev, isOpen: false }));
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('app-modal', handleOpenModal);
      window.removeEventListener('keydown', handleKeyDown);
      delete window.showAppModal;
    };
  }, []);

  if (!modalState.isOpen) return null;

  const handleClose = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  const getIcon = () => {
    switch (modalState.type) {
      case 'success':
        return <CheckCircle size={28} className="feedback-icon icon-success" />;
      case 'error':
        return <XCircle size={28} className="feedback-icon icon-error" />;
      case 'warning':
        return <AlertTriangle size={28} className="feedback-icon icon-warning" />;
      default:
        return <Info size={28} className="feedback-icon icon-info" />;
    }
  };

  return (
    <div className="feedback-modal-overlay" onClick={handleClose}>
      <div
        className={`feedback-modal-card type-${modalState.type}`}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <div className="feedback-modal-header">
          <div className="feedback-modal-title-wrap">
            {getIcon()}
            <h3 className="feedback-modal-title">{modalState.title}</h3>
          </div>
          <button className="feedback-modal-close" onClick={handleClose} aria-label="Fermer">
            <X size={20} />
          </button>
        </div>

        <div className="feedback-modal-body">
          <p className="feedback-modal-text">{modalState.message}</p>
        </div>

        <div className="feedback-modal-footer">
          <button className="feedback-modal-button" onClick={handleClose}>
            Compris
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
